import Vue from "vue";
import vSelect from 'vue-select'
import OpenIndicator from "./components/OpenIndicator";
import MediaMap from "./MediaMap";

const SELECTOR = "#media-map";

document.addEventListener("DOMContentLoaded", () => {
    const map = document.querySelector(SELECTOR);
    if (map) {
        vSelect.props.components.default = () => ({ OpenIndicator });
        Vue.component('v-select', vSelect)
        new Vue({
            el: SELECTOR,
            render: h => h(MediaMap),
        });
    }
});
